import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import "./autocomplete.scss";

const Autocomplete = ({
  className,
  results,
  onChange,
  onSelect,
  placeholder,
  showArrow
}) => {
  const [value, setValue] = useState("");
  const [hasFocus, setFocus] = useState(false);

  const onChangeHandler = event => {
    setValue(event.target.value);
    if (onChange) {
      onChange(event.target.value);
    }
  };
  const onSelectHandler = select => {
    if (onSelect) {
      setValue("");
      onSelect(select);
    }
  };

  useEffect(() => {
    if (value) {
      setValue(value);
    }
  });

  return (
    <div
      className={`autocomplete ${showArrow && `showarrow`} ${
        hasFocus ? `open` : ""
      }`}
    >
      <input
        type="text"
        autoComplete="nope"
        value={value}
        onChange={e => onChangeHandler(e)}
        onFocus={() => {
          setFocus(true);
        }}
        onBlur={() => {
          setTimeout(() => setFocus(false), 500);
        }}
        placeholder={!hasFocus ? placeholder : ""}
      />
      {hasFocus && results && (
        <ul className="resultList">
          {results.map((result, index) => (
            <li
              onClick={() => onSelectHandler(results[index])}
              key={result.ineId}
            >
              {result.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

Autocomplete.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func
};

export default Autocomplete;
